import Home from './Home';
import Search from './Search';
import RelatedSongs from './RelatedSongs';
import ReviewedSongs from './ReviewedSongs';
import ReceivedAsSuggestion from './ReceivedAsSuggestion';
import ReceivedAsTrending from './ReceivedAsTrending';
import UploadedBy from './UploadedBy';

const classes = {
    'Home': Home,
    'Search': Search,
    'RelatedSongs': RelatedSongs,
    'ReviewedSongs': ReviewedSongs,
    'ReceivedAsSuggestion': ReceivedAsSuggestion,
    'ReceivedAsTrending': ReceivedAsTrending,
    'UploadedBy': UploadedBy,
};

export default function filtersFactory(name, data) {
    return new classes[name](data);
}
